import { useState } from 'react'
import { TagListEditor } from './TagListEditor'

interface Props {
  title: string
  initial: string[]
  onConfirm: (next: string[]) => void
  onCancel: () => void
}

/**
 * The note options for a category, edited as a list rather than a line of
 * comma-separated text.
 *
 * Its own dialog rather than PromptDialog: that one asks for a single string
 * and is right for a name or a station, but a list asked for as text needed a
 * paragraph explaining the separator before the field could be used at all.
 *
 * Saving an empty list is allowed and means something, this category offers
 * no ready-made notes, only the free-text box the till always has.
 */
export function NoteOptionsDialog({ title, initial, onConfirm, onCancel }: Props) {
  const [options, setOptions] = useState<string[]>(initial)
  /** Yazılmış ama "Ekle"ye basılmamış not: Kaydet'te kaybolmasın. */
  const [pending, setPending] = useState('')

  const save = () => {
    const t = pending.trim()
    const dup = options.some((o) => o.toLocaleLowerCase('tr-TR') === t.toLocaleLowerCase('tr-TR'))
    onConfirm(t && !dup ? [...options, t] : options)
  }

  return (
    <div className="dlg" role="dialog" aria-modal="true">
      <div className="dlg__card dlg__card--ask">
        <h2>{title}</h2>

        {/* Ne olduğunu bilmeyen için tek cümle: boşken gösteriliyor. */}
        {options.length === 0 && (
          <p className="dlg__empty">
            Garsonun bu kategorideki ürünlere tek dokunuşla ekleyeceği kısa notlar.
            Mutfak fişinde ürünün altında yazar. Örn. Acısız, Az pişmiş, Buzsuz.
          </p>
        )}
        <TagListEditor
          value={options}
          onChange={setOptions}
          placeholder="Not yazın (örn. Acısız)"
          emptyText=""
          onPendingChange={setPending}
        />

        <div className="dlg__buttons dlg__buttons--even">
          <button type="button" className="btn btn--ghost" onClick={onCancel}>
            Vazgeç
          </button>
          <button type="button" className="btn btn--primary" onClick={save}>
            Kaydet
          </button>
        </div>
      </div>
    </div>
  )
}
